import "./SystemSettingsScreen.scss";
import {useDispatch} from "react-redux";
import {useEffect} from "react";
import {setCurrentNavParams, setSideMenuView} from "../../store/actions/header.action";
import TabsWrapperComponent, {
    TabComponent,
    TabContentComponent,
    TabsComponent
} from "../../shared/components/tabs/tabsComponent";
import DropDownsComponent from "./drop-downs/DropDownsComponent";
interface SystemSettingsComponentProps {

}

const DROPDOWNS = 'dropdowns';



const SystemSettingsScreen = (props: SystemSettingsComponentProps) => {

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setCurrentNavParams("System Settings", "System Settings"));
        dispatch(setSideMenuView('default'));
    }, [dispatch]);

    return (
        <div className={'system-settings-component screen'}>
            <div className={"screen-content-wrapper"}>
            <TabsWrapperComponent>
                <TabsComponent>
                    <TabComponent label={"DROPDOWNS"} value={DROPDOWNS}/>
                </TabsComponent>
                <TabContentComponent value={DROPDOWNS} selectedTab={'dropdowns'}>
                    <DropDownsComponent/>
                </TabContentComponent>
            </TabsWrapperComponent>
            </div>
        </div>
    );

};

export default SystemSettingsScreen;